import React from 'react';
import { motion } from 'framer-motion';
import { User, Heart, Briefcase, XCircle } from 'lucide-react';
export function WhoIsThisFor() {
  return <section className="py-12 bg-aged-cream-green relative overflow-hidden" data-id="element-340">
      {/* Geometric decorations */}

      <div className="container mx-auto px-4 relative z-10" data-id="element-341">
        <div className="text-center mb-16" data-id="element-342">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-343">
            Esto no es para gente perfecta
          </h2>
          <p className="text-xl text-slate-600 mb-8" data-id="element-344">Es para mujeres reales.</p>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-345">
            Mujeres que trabajan. Que son mamás. Que están cansadas. Que quieren
            hacerlo mejor, pero sin sufrir.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-6 mb-16" data-id="element-346">
          {['Si odias los presupuestos rígidos, esto es para ti.', 'Si estás harta de sentirte mal con el dinero, esto es para ti.', 'Si quieres dejar de sobrevivir quincena tras quincena, esto es para ti.'].map((text, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-aged-green p-6 rounded-xl border-l-4 border-[#f4c430] overflow-hidden" data-id="element-347">
              <p className="text-lg text-white font-medium relative z-10" data-id="element-348">
                {text}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto bg-white border-4 border-[#2d5016] rounded-xl p-8" data-id="element-349">
          <h3 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-350">
            La quincena no es el problema
          </h3>
          <p className="text-3xl font-bold mb-6" style={{
          color: '#f4c430'
        }} data-id="element-351">
            El sistema sí
          </p>
          <p className="text-xl text-slate-600 mb-4" data-id="element-352">Y hoy puedes cambiarlo.</p>
          <p className="text-lg text-slate-600" data-id="element-353">
            No con más fuerza de voluntad. No con más promesas.
          </p>
          <p className="text-2xl font-bold mt-4" style={{
          color: '#f4c430'
        }} data-id="element-354">
            Con estructura.
          </p>
        </div>
      </div>
    </section>;
}